import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installE2EVisualReview } from './e2eVisualReview';
import { applyTextSizeToDocument, readStoredTextSize } from './utils/textSize';

applyTextSizeToDocument(readStoredTextSize());

if (process.env.REACT_APP_E2E_VISUAL_REVIEW === '1') {
  installE2EVisualReview();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
